import { render, staticRenderFns } from "./EducationBlocks.vue?vue&type=template&id=7f52eb2c&scoped=true&"
import script from "./EducationBlocks.vue?vue&type=script&lang=js&"
export * from "./EducationBlocks.vue?vue&type=script&lang=js&"
import style0 from "./EducationBlocks.vue?vue&type=style&index=0&id=7f52eb2c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f52eb2c",
  null
  
)

export default component.exports